import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRepeat: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconRepeat"><Path d="M7.5 18.5H2.5V3.5H21.5V18.5H12M14.5 15.5L11.5 18.5L14.5 21.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconRepeat;
